import {ReactComponent as ShareIcon} from './share.svg'

function Share() {
  return <ShareIcon />
}

export default Share
